


















import { Vue, Component, Prop } from "vue-property-decorator";
import type { ICustomStylingClass, SwatchType } from "./types/custom.t";
import CustomContainer from "./CustomContainer.vue";
import SwatchBackground from "./atom.swatchbackground.vue";
import CustomTooltip from "./CustomTooltip.vue";
import CustomText from "@/components/Globals/CustomText.vue";

@Component({ components: { CustomText, CustomContainer, SwatchBackground, CustomTooltip } })
export default class Swatch extends Vue {
  @Prop()
  customsClasses?: ICustomStylingClass[];

  @Prop()
  swatchData!: SwatchType;
}
